import { EntityTypes } from "../../EntityTypes";
import { ITimestampable, IHydraResource } from "../../types";

export enum GroupTaskStatus {
    DONE = "done",
    TODO = "todo",
}

export interface IGroupTaskResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.GROUP_TASK;
    title: string;
    description: string;
    rank: number;
    status: GroupTaskStatus;
    learner: string;
    groupSpace: string;
}

export const isGroupTaskResource = (resource: IHydraResource): resource is IGroupTaskResource => {
    return resource["@type"] === EntityTypes.GROUP_TASK;
};
